var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightButton = function SvgRightButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.16 927.91A35 35 0 0 1 329.61 867l384.95-349.82a8.49 8.49 0 0 0 0-12.09L329.51 152.22a35 35 0 0 1 47.29-51.61l385.08 352.87a78.48 78.48 0 0 1-.24 115.5L376.69 918.82a34.87 34.87 0 0 1-23.53 9.09"
  })));
};
export default SvgRightButton;